/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Filters from "../../../components/Filters";
import { ControlTable } from "../../../components/Table";
import { createInvoiceMappingTaxInvoice, getTaxInvoiceList, mappingToEtcInvoice } from "../../../apis/invoices";
import { getParams } from "../../../utils/params";
import { autoHyphen } from "../../../utils/replace";
import { getDay } from "../../../utils/date";
import useForm from "../../../hooks/useForm";
import { cloneDeep, isEmpty } from "lodash";
import { useHistory } from "react-router-dom";
import Modal, { ModalHeader } from "../../../components/Modal";
import Button from "../../../components/Button";
import TaxInvoiceDetail from "../Tax/TaxInvoiceDetail";
import systemAlert from "../../../utils/systemAlert";
import { toast } from "../../../utils/toast";
import { useSelector } from "react-redux";

const TaxInvoiceMapping = ({
  open,
  setOpen,
  data,
  setData,
  type,
  listSubmit,
  requesterType = "invoice"
}) => {
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const history = useHistory();
  const [fields, setFields] = useState([]);
  const [rowData, setRowData] = useState({});
  const [detailOpen, setDetailOpen] = useState(false);
  const [targetPermission, setTargetPermission] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      setTargetPermission(permissions.find(p => p.code === 'TAX_INVOICE'));
    }
  }, [permissions]);

  useEffect(() => {
    setFields([
      { title: "전송일자", key: "issueDate", type: 'date' },
      { title: "작성일자", key: "writeDate", type: 'date' },
      { title: "상호", key: type === "sales" ? "byrCorpName" : "supCorpName" },
      { title: "대표자명", key: type === "sales" ? "byrRepName" : "supRepName" },
      {
        title: "사업자번호",
        key: type === "sales" ? "byrBizNo" : "supBizNo",
        onValue: (value) => {
          return autoHyphen("comNum", value);
        },
      },
      { title: "대표품목", key: "itemName" },
      {
        title: "공급가액",
        key: "supplyAmt",
        type: 'comma'
      },
      {
        title: "세액",
        key: "taxAmt",
        type: 'comma'
      },
      {
        title: "합계금액",
        key: "totalAmt",
        type: 'comma'
      },
      {
        title: 'Wecake발행',
        key: 'isIssuedFromService',
        onValue: (value) => value ? 'Y' : 'N'
      }
    ]);
  }, [type]);

  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    filterSubmit,
    list, setList,
    selectedList, setSelectedList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm({
    order: [{ issueDate: "desc" }],
    range: {
      issueDate: isEmpty(history.location.state) ? [getDay(7), getDay()] : history.location.state.date,
    },
    page: 0,
    limit: 10,
    type
  });

  useEffect(() => {
    submit(form);
    setSubmit(submit);
  }, [type]);

  const submit = (params) => {
    let _params = cloneDeep(params);
    const invoiceType = _params.taxInvoiceType || "all";
    const type = _params.type || "sales";
    delete _params.type;
    delete _params.taxInvoiceType;

    if (!isEmpty(_params["range.issueDate"])) {
      _params.range.issueDate = {
        from: _params["range.issueDate"][0],
        to: _params["range.issueDate"][1]
      };
      delete _params["range.issueDate"];
    }

    getTaxInvoiceList(type === 'sales' ? 'sales' : 'purchase', invoiceType, { ...getParams(_params) })
      .then((res) => {
        setList(res.data.invoices);
        setTotal(res.data.totalCount);
      })
      .catch((err) => {
        console.error(err.response);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const filters = [
    {
      isHide: requesterType === "invoice",
      title: "구분",
      type: "select",
      key: "type",
      options: {
        list: [{
          label: "매출",
          value: "sales",
        },
        {
          label: "매입",
          value: "purchase",
        }]
      }
    },
    {
      title: "구분",
      type: "select",
      key: "taxInvoiceType",
      options: {
        list: [
          {
            label: "전자세금계산서",
            value: "all",
          },
          {
            label: "종이세금계산서",
            value: "paper_tax_invoice",
          },
        ]
      }
    },
    {
      title: '조회기간',
      type: 'customdatepicker',
      key: "range.issueDate",
      wrapClassName: requesterType === "invoice" ? "" : "small-padding"
    },
  ];

  const handleOnRowClick = (data, e) => {
    if (e.target.tagName !== "TR" && e.target.tagName !== "TD") return;
    setRowData(data);
    setDetailOpen(true);
  };

  const getCheckboxDisabled = (data) => {
    let disabled = false;

    if (!isEmpty(selectedList)) {
      if (
        data.byrCorpName !== selectedList[0].byrCorpName ||
        data.byrRepName !== selectedList[0].byrRepName ||
        data.byrBizNo !== selectedList[0].byrBizNo
      ) {
        disabled = true;
      }
    }

    return disabled;
  };

  const cancel = () => {
    setData(null);
    setOpen(false);
  };

  const handleOnSupply = () => {
    if (isEmpty(selectedList)) return toast.error('세금계산서를 선택해주세요');
    let body;
    switch (requesterType) {
      case "order":
      case "quotation":

        body = {
          list: selectedList.map((li) => ({
            requestIdx: data.idx,
            mappingIdx: li.idx
          }))
        };

        systemAlert(`해당${requesterType === "quotation" ? "견적서" : "발주서"}에 선택된 세금계산서를 매핑 하시겠습니까?`, {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                mappingToEtcInvoice("taxInvoice", requesterType, body)
                  .then(() => {
                    listSubmit();
                    cancel();
                  });
              }
            }
          ]
        });

        break;

      case "invoice":
        body = {
          list: selectedList.map((li) => ({
            invoiceIdx: data.idx,
            taxInvoiceIdx: li.idx
          }))
        };

        systemAlert('해당 거래명세서에 선택된 세금계산서를 매핑 하시겠습니까?', {
          buttons: [
            {
              color: 'text',
              label: '취소'
            },
            {
              label: '확인',
              onClick: () => {
                createInvoiceMappingTaxInvoice(body).then(() => {
                  listSubmit();
                  cancel();
                });
              }
            }
          ]
        });
        break;

      default:
        break;
    }
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="select-tax-invoice-container">
        <ModalHeader>세금계산서 매핑하기</ModalHeader>
        <Filters
          isLoading={isLoading}
          filters={filters}
          submit={filterSubmit}
          form={form}
          onChange={handleOnChange}
        />
        <ControlTable
          isControl
          isHideAllCheck
          fields={fields}
          list={list}
          selectedList={selectedList}
          setSelected={setSelectedList}
          isLoading={isLoading}
          total={total}
          page={page}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
          submit={handleSubmit}
          onSelect={handleOnRowClick}
          checkboxDisabled={getCheckboxDisabled}
        />
        <div className="submit-button-wrap float-right margin-top-32">
          <Button
            className="button"
            size="lg"
            label="취소"
            color="text"
            action={cancel}
          />
          <Button
            className="button"
            size="lg"
            label="적용하기"
            action={handleOnSupply}
          />
        </div>
        {detailOpen && (
          <TaxInvoiceDetail
            open={detailOpen}
            setOpen={setDetailOpen}
            list={rowData}
            setList={setRowData}
            permission={targetPermission}
          />
        )}
      </div>
    </Modal>
  );
};

export default TaxInvoiceMapping;
